export const companyInfo = {
  name: 'Multifierros Spa',
  shortName: 'MULTIFIERROS',
  slogan: 'Fortifica la Minería',
  tagline: 'INDUSTRIA MINERA · FORTIFICACIÓN · ESTRUCTURAS',
  description: 'Multifierros Spa es un proveedor nacional especializado en fabricación de marcos viga, marcos reticulados, elementos de anclaje y corte de planchas para la industria minera. Adaptamos cada solución a los requerimientos específicos de tu proyecto.',
  longDescription: 'Multifierros Spa es un proveedor nacional enfocado en entregar productos y soluciones en fortificación para la industria minera en general. Con un enfoque en la satisfacción del cliente, nuestra capacidad de adaptación nos permite responder de manera eficiente a las diversas necesidades del sector. Aseguramos entregas puntuales y alineadas con los requerimientos específicos de nuestros clientes.',
  phones: ['+56 9 5813 9926'],
  emails: ['ventas@multifierros.cl', 'administracion@multifierros.cl'],
  address: 'Camino la Gonzalina - Parcela 8 - Cachapoal, Rancagua, Chile',
  city: 'Rancagua',
  country: 'Chile',
};

export const stats = [
  { value: '+500', label: 'PROYECTOS' },
  { value: '+15', label: 'AÑOS' },
  { value: '+80', label: 'CLIENTES' },
  { value: '100%', label: 'ACERO CALIDAD' },
];

export const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Fabricación', href: '#fabricacion' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Logística', href: '#logistica' },
  { label: 'Quiénes Somos', href: '#quienes-somos' },
  { label: 'Clientes', href: '#clientes' },
  { label: 'Contacto', href: '#contacto' },
];

export const clients = [
  'METRO',
  'PRODALAM',
  'BESALCO',
  'AURA INGENIERÍA',
  'DMC MINING',
  'IMEL',
];

export const services = [
  {
    id: 'srv1',
    number: '01',
    icon: 'ri-hammer-line',
    title: 'Fabricación de Marcos Viga',
    description: 'Fabricamos marcos de viga personalizados conforme a las especificaciones del cliente, utilizados para el sostenimiento de roca en excavaciones. Fabricados en acero A-36 con recubrimientos epóxicos o galvanizados para máxima resistencia.',
    tags: ['Acero A-36', 'Recubrimiento Epóxico', 'Galvanizado'],
  },
  {
    id: 'srv2',
    number: '02',
    icon: 'ri-grid-line',
    title: 'Marcos Reticulados',
    description: 'Marcos de fabricación a medida según descripción del cliente, para aplicaciones de fortificación en excavaciones. Fabricados en acero A-630-420 bajo procesos de soldadura GMAW, ofreciendo soluciones robustas y confiables.',
    tags: ['Acero A-630-420', 'Soldadura GMAW', 'A Medida'],
  },
  {
    id: 'srv3',
    number: '03',
    icon: 'ri-scissors-cut-line',
    title: 'Corte y Dimensionado de Planchas',
    description: 'Amplia gama de servicios de corte: oxicorte, plasma CNC y guillotina. Equipos de última generación con software CAD para cortes precisos en planchas de 3mm hasta 50mm de espesor, ancho máximo 2500mm.',
    tags: ['Plasma CNC', 'Oxicorte', 'Guillotina', 'CAD'],
  },
  {
    id: 'srv4',
    number: '04',
    icon: 'ri-flashlight-line',
    title: 'Soldadura GMAW',
    description: 'Procesos de soldadura certificados para uniones de alta resistencia en aceros estructurales y de bajo aleación. Equipos semiautomáticos de última generación para mayor productividad y calidad de terminación.',
    tags: ['Certificada', 'Alta Resistencia', 'Acero Estructural'],
  },
  {
    id: 'srv5',
    number: '05',
    icon: 'ri-shield-check-line',
    title: 'Recubrimiento Anticorrosivo',
    description: 'Aplicación de recubrimientos epóxicos y galvanizado para proteger estructuras en ambientes agresivos como túneles mineros. Tratamientos que extienden la vida útil de cada componente.',
    tags: ['Epóxico', 'Galvanizado', 'Anti-humedad'],
  },
  {
    id: 'srv6',
    number: '06',
    icon: 'ri-tools-line',
    title: 'Fabricación a Medida',
    description: 'Capacidad de adaptación a los requerimientos específicos de cada cliente, garantizando entregas puntuales y alineadas con los estándares técnicos más exigentes de la industria minera.',
    tags: ['Personalizado', 'Entregas Puntuales', 'Soporte Técnico'],
  },
];

export const products = [
  {
    id: 'prod1',
    badge: 'ACERO A-36 · PERSONALIZADO',
    title: 'Marcos Viga',
    description: 'Marcos de viga diseñados para el sostenimiento de roca en excavaciones mineras. Soportan las cargas ejercidas por el terreno. Disponibles con recubrimiento epóxico o galvanizado para resistencia a la corrosión.',
    imageSeq: 'prod-marcos-viga',
  },
  {
    id: 'prod2',
    badge: 'ACERO A-630-420 · SOLDADURA GMAW',
    title: 'Marcos Reticulados',
    description: 'Marcos reticulados fabricados a medida para aplicaciones de fortificación en excavaciones. Construidos bajo procesos de soldadura GMAW con capacidad de ajustar materiales y procesos a cada proyecto.',
    imageSeq: 'prod-marcos-reticulados',
  },
  {
    id: 'prod3',
    badge: 'PERNOS DE ANCLAJE Y FORTIFICACIÓN',
    title: 'FABRICACION DE SPLIT- SET - PLANCHUELAS - BARRAS HELICOIDALES',
    description: 'Fabricación de splitsets, planchuelas de anclaje y barras helicoidales para fortificación de túneles y excavaciones mineras. Elementos de anclaje por fricción de alta resistencia, fabricados bajo especificaciones técnicas para sostenimiento de roca en condiciones subterráneas exigentes.',
    imageSeq: 'prod-splitset',
  },
  {
    id: 'prod4',
    badge: 'FIJACIÓN Y SUJECIÓN',
    title: 'Tuercas, Placas y Acoples',
    description: 'Tuercas de fijación, placas de sujeción, acoples y acuñadores para sistemas completos de anclaje en túneles mineros. Fabricados con los más altos estándares de calidad.',
    imageSeq: 'prod-tuercas-placas',
  },
  {
    id: 'prod6',
    badge: 'BLINDAJE INDUSTRIAL · ACERO',
    title: 'Anillos de Blindaje',
    description: 'Fabricación de anillos de blindaje industriales de acero para protección de equipos y estructuras en entornos mineros. Diseñados y soldados bajo especificaciones técnicas para máxima resistencia y durabilidad.',
    imageSeq: 'prod-anillos-blindaje',
  },
  {
    id: 'prod7',
    badge: 'MINERÍA · CONSTRUCCIÓN · INDUSTRIA',
    title: 'Fabricación Estructuras Metálicas',
    description: 'Estructuras metálicas para los sectores minería, construcción e industria.',
    imageSeq: 'prod-estructuras-metalicas',
  },
];

export const featuredProjects = [
  {
    id: 'proy1',
    year: '2024',
    category: 'Minería',
    client: 'Codelco Metro',
    title: 'Proyecto Codelco Metro',
    description: 'Fabricación y suministro de marcos viga y elementos de anclaje para operaciones subterráneas de Codelco División El Teniente. Más de 800 marcos fabricados bajo especificaciones ASTM.',
    imageSeq: 'proy-codelco-metro',
  },
  {
    id: 'proy2',
    year: '2024',
    category: 'Infraestructura',
    client: 'Metro de Santiago',
    title: 'Extensión Línea 7 Metro',
    description: 'Suministro de elementos de anclaje y barras autoperforantes para la extensión de la Línea 7 del Metro de Santiago. Proyecto ejecutado con altos estándares de seguridad.',
    imageSeq: 'proy-metro',
  },
  {
    id: 'proy3',
    year: '2023',
    category: 'Minería',
    client: 'DMC Mining',
    title: 'Fortificación Túnel DMC',
    description: 'Provisión de marcos reticulados A-630-420 y pernos autoperforantes para proyecto de desarrollo minero. Adaptación de geometría a perfiles de excavación irregulares.',
    imageSeq: 'proy-dmc',
  },
];

export const companyValues = [
  { icon: 'ri-medal-line', title: 'Calidad Garantizada', desc: 'Acero A-36 y A-630-420 certificado' },
  { icon: 'ri-tools-line', title: 'Fabricación a Medida', desc: 'Adaptamos cada producto a tu proyecto' },
  { icon: 'ri-truck-line', title: 'Entregas Puntuales', desc: 'Cumplimiento de plazos comprometidos' },
  { icon: 'ri-customer-service-2-line', title: 'Soporte Técnico', desc: 'Acompañamiento en todo el proceso' },
];

export const sucursales = [
  {
    name: 'Casa Matriz',
    address: 'Camino la Gonzalina - Parcela 8',
    city: 'Cachapoal, Rancagua, Chile',
    imageSeq: 'suc-rancagua',
  },
];

export const mision = 'Somos una empresa especializada en fabricación de productos de acero para la industria minera, orientados a satisfacer las necesidades de fortificación, anclaje y estructuras metálicas. Guiados por altos estándares de seguridad, calidad y tecnología, procuramos agregar valor a nuestra organización, la de nuestros clientes y al entorno en el cual nos desenvolvemos.';

export const vision = 'Consolidarnos como un actor importante en fabricación de marcos de sostenimiento y estructura metálica para la minería, marcando diferencia en procesos que garanticen la calidad esperada por nuestros clientes, innovación e inclusión, incorporando criterios de sustentabilidad, responsabilidad social y gobernanza que sean apreciados y valorados por todas nuestras partes relacionadas.';

export const carouselSlides = [
  {
    id: 'slide-1',
    line1: 'Marcos Viga',
    line2: 'Sostenimiento de Túneles',
    imageSeq: 'slide-marcos-viga',
  },
  {
    id: 'slide-2',
    line1: 'Marcos Reticulados',
    line2: 'Fortificación de Excavaciones',
    imageSeq: 'slide-marcos-ret',
  },
  {
    id: 'slide-3',
    line1: 'Split-Set',
    line2: 'Anclaje por Fricción',
    imageSeq: 'slide-splitset',
  },
  {
    id: 'slide-4',
    line1: 'Tuercas y Placas',
    line2: 'Sistemas de Fijación',
    imageSeq: 'slide-tuercas',
  },
  {
    id: 'slide-6',
    line1: 'Anillos de Blindaje',
    line2: 'Protección Industrial',
    imageSeq: 'slide-anillos',
  },
];